import { useEffect } from "react";
import { useStepContext } from "./StepperContext";
import isFunction from "lodash/isFunction";

export const useStepperRegisterValidation = (
  step: number,
  validate: () => boolean,
  canSaveAndExit?: () => boolean,
) => {
  const { registerValidation, registerCanSaveAndExit } = useStepContext();

  useEffect(() => {
    registerValidation(step, validate);

    if (isFunction(canSaveAndExit)) {
      registerCanSaveAndExit(canSaveAndExit);
    }
  }, [
    step,
    validate,
    canSaveAndExit,
    registerValidation,
    registerCanSaveAndExit,
  ]);
};
